import React, { FC } from 'react'
import Select from 'react-select'
import clsx from 'clsx'
import { FieldErrors } from 'react-hook-form'

import { FenceHeightOption } from '../../../../../pages/organizer/manage/components/FenceHeightOption'

import MessageHelperComp from '../../../../../helpers/MessageHelper'

import { IJudgeOption } from '../../../../../models/event-fees/event-fees.interface'
import { UseFormSetValue, UseFormTrigger, UseFormWatch } from 'react-hook-form/dist/types/form'
import { IScoreCardInterface } from '../../../../../models/score-cards/score-cards.interface'

import { fenceHeightOptions } from '../../../../../const/score-card-const'

interface FenceHeightProps {
  watch: UseFormWatch<IScoreCardInterface>
  setValue: UseFormSetValue<IScoreCardInterface>
  errors: FieldErrors<IScoreCardInterface>
  trigger: UseFormTrigger<IScoreCardInterface>
  className?: string
  editable?: boolean
}
export const FenceHeight: FC<FenceHeightProps> = ({
  className,
  watch,
  setValue,
  errors,
  trigger,
  editable,
}) => {
  const [menuIsOpen, setMenuIsOpen] = React.useState(false)

  return (
    <div
      className={clsx('relative z-20 flex items-center flex-1 justify-between gap-2', className)}
    >
      <p
        className={clsx(
          'absolute left-3 top-1/2 -translate-y-1/2',
          !watch('fenceHeight') && 'opacity-50'
        )}
        onClick={() => editable && setMenuIsOpen(true)}
      >
        Fence height
      </p>
      <Select
        menuIsOpen={menuIsOpen}
        onMenuClose={() => setMenuIsOpen(false)}
        onMenuOpen={() => setMenuIsOpen(true)}
        isDisabled={!editable}
        name="fenceHeight"
        className="w-full text-right ml-auto text-SeabiscuitDark200ThemeColor bg-transparent"
        classNamePrefix="entries-select"
        isClearable={false}
        isSearchable={true}
        placeholder="Select..."
        components={{ Option: FenceHeightOption }}
        styles={{
          input: (provided) => ({
            ...provided,
            direction: 'rtl',
          }),
          menu: (provided) => ({
            ...provided,
            textAlign: 'left',
          }),
          singleValue: (provided) => ({
            ...provided,
            fontSize: '16px !important',
            backgroundColor: 'transparent',
            color: 'black',
          }),
          control: (provided) => ({
            ...provided,
            backgroundColor: 'transparent',
            border: 'none',
          }),
          dropdownIndicator: () => ({
            display: 'none',
          }),
        }}
        value={
          watch('fenceHeight')
            ? { label: watch('fenceHeight'), value: watch('fenceHeight'), disable: false }
            : null
        }
        onChange={(value) => {
          if (value?.value) {
            setValue('fenceHeight', value?.value)
            trigger().then()
          }
        }}
        options={fenceHeightOptions}
        isOptionDisabled={(option: IJudgeOption) => option.disable}
      />
      {!!errors?.fenceHeight?.message ? (
        <MessageHelperComp
          className="absolute z-0 bottom-0 right-0 translate-y-full"
          isError={true}
          message={errors?.fenceHeight?.message}
        />
      ) : null}
    </div>
  )
}
